/*
 * All the words and settings the demo pages use.
 *
 * Keeping them here means you can change what the site says without opening a
 * component. If you want to reword the pitch, this is the only file to edit.
 */

/** The three alphabet names the demonstration page cycles through. */
export const LANGUAGES = ['ALPHA', 'BRAVO', 'CHARLIE']

/** Characters the demonstration page knows how to turn into a color. */
export const ALPHABET =
  'abcdefghijklmnopqrstuvwxyz' +
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
  '0123456789'

/** How long each alphabet card stays on screen before the next one slides in. */
export const CAROUSEL_MS = 3200

export const ABOUT = {
  heading: 'About us',
  body:
    'At Colorantí, our color-based encryption technology bridges the gap ' +
    'between human understanding and digital security. We encode data through ' +
    'our Hexa-Chroma Matching System, using the universality of color — ' +
    'something instantly familiar across every language and culture — to ' +
    "deliver encryption that's both approachable and unbreakable."
}

export const WHAT_WE_DO = {
  heading: 'What we do',
  body:
    'Unlike traditional methods reliant on mathematical complexity, we turn ' +
    'your data into sequences of color that are virtually impossible to ' +
    'crack. Every fragment of your data is given its own color in one of ' +
    'three alphabets, so what ends up stored looks like nothing at all.'
}

/** Sits under the three cards on the demonstration page. */
export const CAROUSEL_NOTE =
  'The same text is shown three times, once in each alphabet. Every alphabet ' +
  'pairs the letters with a different set of colors, so the same words come ' +
  'out looking completely different each time.'

export const ATTACKS = [
  { 
    name:'Malware', color:'#2ecc48ff', 
    example:'Hidden app acting like a thief inside your device.',
    expanded:'A malware cyber attack involves malicious software designed to harm, disrupt, or gain unauthorized access to computer systems, networks, or data without the user\'s knowledge.'
  },

  { 
    name:'Brute Force', color:'#e74c3c',
    example:'Repeatedly guesses passwords until one works.',
    expanded:'A brute force cyber attack is a trial-and-error method used by attackers to systematically guess passwords, login credentials, or encryption keys until the correct combination is found'
  },

  { 
    name:'DDoS', color:'#3498db', 
    example:'Overloads website traffic so real users are blocked.',
    expanded:'A distributed denial-of-service (DDoS) attack is a malicious cyberattack designed to overwhelm a targeted website, server, or network with a flood of traffic from multiple sources, rendering it unavailable to legitimate users.'
  },

  {
    name:'Phishing', color:'#f1c40fff',
    example:'Tricks users into giving away sensitive information.',
    expanded:'A phishing cyber attack is a deceptive attempt by attackers to trick individuals into revealing sensitive information, such as passwords, credit card numbers, or personal data, by impersonating trustworthy entities through emails, messages, or fake websites.'   
  },

  {
    name:'SQL Injection', color:'#9b59b6ff',
    example:'Injects malicious SQL code into a database query.',
    expanded:'An SQL injection cyber attack is a technique where attackers exploit vulnerabilities in a web application\'s database layer by inserting malicious SQL code into input fields, allowing them to manipulate the database and gain unauthorized access to sensitive data.'
  }
]

// Mock composite scores per attack
export const MOCK_SCORES = {
  'Malware': { AES:68, RSA:64, Coloranti:88 },
  'Brute Force': { AES:72, RSA:60, Coloranti:92 },
  'DDoS': { AES:55, RSA:58, Coloranti:81 }
}

export const COLORANTI_BY_ATTACK = {
  'Malware':'#2ecc71',
  'Brute Force':'#e74c3c',
  'DDoS':'#3498db',
  'Phishing':'#f1c40f',
  'SQL Injection':'#9b59b6'
}
